import React, { useContext, useEffect } from 'react';
import { useUser } from '../../state/user';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import ParentInviteWithEmail from './ParentInviteWithEmail';
import { useToggles } from '../../state/toggles';
import ParentInviteWithPhoneNumber from './ParentInviteWithPhoneNumber';
import { useAppDispatchers } from '../../state/app';
import { useCheckMobileScreen } from '../../hooks/useCheckMobileScreen';

const ParentInvite = () => {
  const { userIsTeen } = useUser();
  const { analytics, segment } = useContext(AnalyticsContext);
  const { trackCustomEvent } = useAppDispatchers();

  const { kidFirstRegParentInviteV1 } = useToggles();
  const isMobile = useCheckMobileScreen();

  useEffect(() => {
    analytics.trackEvent('Parent Invite Viewed', {
      eventProps: {
        is_teen: userIsTeen,
        position: 'prereg'
      }
    });
  }, []);

  const inviteParent = (parentEmail?: string) => {
    trackCustomEvent({
      eventName: 'Invite Parent',
      eventProperties: {
        parent_email: parentEmail
      },
      userAlias: {
        alias_name: 'segment_anonymous_id',
        alias_label: segment.getAnonymousId()
      }
    });
    analytics.trackEvent('Parent Invite Sent', {
      eventProps: {
        email: parentEmail,
        nextRegisterStep: userIsTeen ? 'validate' : 'parent_invite_complete',
        prospect: 'kid_invited',
        position: 'prereg'
      }
    });
  };

  const shouldRenderWithPhoneNumber =
    isMobile &&
    kidFirstRegParentInviteV1.enabled &&
    kidFirstRegParentInviteV1.variables?.variant === 'sms';

  return shouldRenderWithPhoneNumber ? (
    <ParentInviteWithPhoneNumber onParentInvite={inviteParent} />
  ) : (
    <ParentInviteWithEmail onParentInvite={inviteParent} />
  );
};

export default ParentInvite;
